import React, { useCallback } from 'react'
import {
  Button,
  Input,
  Select,
  Textarea,
  useInput,
  useSelect,
  useTextarea,
  useViewport
} from '@chilecompra/react-kit/components'
import { checkInputErrorEmail, checkInputErrorRequired } from '@chilecompra/react-kit/utils'
import { REACT_APP_MAIL_DIRECTION } from '../../config/settings/environment'
import AboutSiteNavButton from '../../components/Navigation/AboutSiteNavButton'
import {
  Description,
  GridContainer,
  GridItem,
  HideContainer,
  MailLink,
  Root,
  Title
} from './AboutSuggestDataSection.styles'

/**
 * The AboutSuggestDataSection's container.
 */
const AboutSuggestDataSection = () => {
  const { size } = useViewport()
  const {
    error: nameError,
    value: nameValue,
    onChange: handleChangeName
  } = useInput({ errorCallbacks: [checkInputErrorRequired()] })
  const {
    error: emailError,
    value: emailValue,
    onChange: handleChangeEmail
  } = useInput({ errorCallbacks: [checkInputErrorRequired(), checkInputErrorEmail()] })
  const {
    error: typeError,
    value: typeValue,
    onChange: handleChangeType
  } = useSelect({ errorCallbacks: [checkInputErrorRequired()] })
  const {
    error: messageError,
    value: messageValue,
    onChange: handleChangeMessage
  } = useTextarea({ errorCallbacks: [checkInputErrorRequired()] })
  const handleSubmit = useCallback(
    event => {
      event.preventDefault()
      // TODO: call to the corresponding thunk.
    },
    [emailValue, messageValue, nameValue, typeValue]
  )

  return (
    <Root onSubmit={handleSubmit}>
      <GridContainer padding="0 0 26px">
        <AboutSiteNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Sugerir datos</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Description>
            Para mejorar la calidad de los contenidos que estamos mostrando, nos interesa conocer tu sugerencia respecto
            a nuevos cruces de información, nuevos reportes, u otro tipo de contenido que consideres relevante.
            <br />
            <br />
            Contáctanos al correo <MailLink href={REACT_APP_MAIL_DIRECTION}>datosabiertos@chilecompra.cl</MailLink>
          </Description>
        </GridItem>
      </GridContainer>
      <HideContainer>
        <GridContainer padding="0 0 9px" spacing={4}>
          <GridItem md={4} xs={12}>
            <Input error={nameError} label="nombre" value={nameValue} onChange={handleChangeName} />
          </GridItem>
          <GridItem md={4} xs={12}>
            <Input error={emailError} label="correo electrónico" value={emailValue} onChange={handleChangeEmail} />
          </GridItem>
          <GridItem md={4} xs={12}>
            <Select
              error={typeError}
              label="tipo de sugerencia"
              // FIXME: replace for the right options.
              options={[{ name: 'Reportes', value: 'reports' }]}
              value={typeValue}
              onChange={handleChangeType}
            />
          </GridItem>
        </GridContainer>
        <GridContainer padding="0 0 28px">
          <GridItem xs={12}>
            <Textarea
              error={messageError}
              info="Ingresa tu consulta o sugerencia"
              label="mensaje"
              maxCount={300}
              maxLength={300}
              rows={8}
              value={messageValue}
              onChange={handleChangeMessage}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem align={size.isUpToMedium ? 'right' : 'center'} xs={12}>
            <Button color="primary" type="submit">
              Enviar
            </Button>
          </GridItem>
        </GridContainer>
      </HideContainer>
    </Root>
  )
}

export default AboutSuggestDataSection
